import { ImsObject } from './ims_object';
import { DynamicStatSchemaResource } from '../resources';
import { FieldSchema, StatDefinition } from './StatDefinition';

export const IMS_TYPE__DYNAMIC_STAT_SCHEMA = 'dynamic_stat_schema';

export class DynamicStatSchema extends ImsObject {
    constructor(resource = new DynamicStatSchemaResource()) {
        super(IMS_TYPE__DYNAMIC_STAT_SCHEMA, resource);
    }

    get name() {
        return this.resource.name;
    }

    get display_name() {
        return this.resource.display_name;
    }

    get description() {
        return this.resource.description;
    }

    get data_frequency() {
        return this.resource.data_frequency;
    }

    get last_updated() {
        return this.resource.last_updated;
    }

    get parent_type() {
        return this.resource.parent_type;
    }

    get field_schemas(): { [fieldName: string]: FieldSchema } {
        return this.resource.field_schemas;
    }

    get rollups() {
        // Rollups are formatted as an array of things like: {"time_slice_mins": 15, "max_data_age_days": 90}
        return this.resource.rollups;
    }

    get is_relationship() {
        return this.resource.is_relationship;
    }

    get relationship_target_asset_column_name() {
        return this.resource.relationship_target_asset_column_name;
    }

    getAsStatDefinition(): StatDefinition {
        return {
            // Pass all properties from resource to prevent properties going missing
            ...this.resource,
            field_schemas: this.field_schemas,
            isDynamicStat: true,
        };
    }
}
